<template>
  <div id="agAGOLConn">
  </div>
</template>


<script>
// components

// server

// modules

export default {
  name: "ag-agol-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/AGOLConnection.vue